import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CampaignSummaryField } from '@fmnts/api/next';
import { FmntsRatingModule } from '@fmnts/components/rating';
import { isNumber } from '@fmnts/core';
import {
  AbstractDeclarativeFieldComponent,
  TemplateBuilder,
  ensureTemplate,
  interpolateTemplate,
} from '@fmnts/declarative-forms';
import { I18nModule } from '@fmnts/i18n';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { Observable, map, of } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'next-rating-summary-field',
  templateUrl: './rating-summary-field.component.html',
  imports: [FmntsRatingModule, I18nModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingSummaryFieldComponent
  extends AbstractDeclarativeFieldComponent<CampaignSummaryField>
  implements OnInit
{
  protected readonly templateBuilder = inject(TemplateBuilder);

  protected readonly icon = faStar;

  protected rating$: Observable<number | null> = of(null);

  ngOnInit(): void {
    const { defaultValue } = this.field.widgetOptions;

    if (isNumber(defaultValue)) {
      this.rating$ = of(defaultValue);
    } else {
      this.rating$ = this.getRating$(this.field);
    }
  }

  /**
   * @param field
   *
   * @returns
   * An observable that emits with the rating
   */
  private getRating$(field: CampaignSummaryField): Observable<number> {
    const { defaultValue } = field.widgetOptions;

    return of(defaultValue).pipe(
      // Ensure that for any emitted value that references a field
      // that it is transformed into templating form of `{{some-field-key}}`
      map((s) => ensureTemplate(s, this.declaration)),
      interpolateTemplate((part) => this.templateBuilder.interpolate(part)),
      map((r) => Number(r)),
    );
  }
}
